<template>
  <div style="width: 100%">
    <v-row no-gutters>
      <span class="checkout-h3 accent--text" style="font-weight: 400">{{
        buyerData.typeDocument === "CNPJ"
          ? $t("payment.form.corporateName")
          : $t("payment.form.fullName")
      }}</span>
    </v-row>
    <v-row no-gutters>
      <v-text-field
        class="rounded-lg"
        :disabled="!!loggedUser || (pendingOrder && !firstPayment)"
        outlined
        autocomplete="name"
        :rules="[rulesValidation.required, rulesValidation.noSpecialChars]"
        v-model="buyerData.customer_name"
        @input="changeInput"
      ></v-text-field>
    </v-row>
    <v-row class="mt-n2" no-gutters>
      <span class="checkout-h3 accent--text" style="font-weight: 400"
        >Email</span
      >
    </v-row>
    <v-row no-gutters>
      <v-text-field
        outlined
        class="rounded-lg"
        v-model="buyerData.customer_email"
        type="email"
        :disabled="!!loggedUser || (pendingOrder && !firstPayment)"
        :rules="[rulesValidation.email]"
        maxlength="60"
        autocomplete="email"
        @blur="getAvailable"
        @input="changeInput('email')"
      ></v-text-field>
    </v-row>
    <v-row class="mt-n2" no-gutters>
      <v-col
        :class="!$vuetify.breakpoint.mdAndUp ? '' : 'pr-2'"
        :cols="
          !$vuetify.breakpoint.mdAndUp
            ? '12'
            : buyerData?.typeDocument === 'foreigner'
            ? '4'
            : '6'
        "
      >
        <v-row no-gutters>
          <span class="checkout-h3 accent--text" style="font-weight: 400">{{
            $t("payment.form.typeDocument")
          }}</span>
        </v-row>
        <v-select
          class="rounded-lg"
          :disabled="!!loggedUser || (pendingOrder && !firstPayment)"
          outlined
          :rules="[rulesValidation.required]"
          :items="typesDocument"
          v-model="buyerData.typeDocument"
          @change="changeInput('typeDocument')"
        ></v-select>
      </v-col>

      <v-col
        v-if="buyerData?.typeDocument === 'foreigner'"
        :class="!$vuetify.breakpoint.mdAndUp ? '' : 'px-2'"
        :cols="$vuetify.breakpoint.mdAndUp ? '4' : '12'"
      >
        <v-row no-gutters>
          <span class="checkout-h3 accent--text" style="font-weight: 400">{{
            $t("payment.form.nationality")
          }}</span>
        </v-row>

        <v-autocomplete
          class="rounded-lg"
          outlined
          :disabled="pendingOrder && !firstPayment"
          :rules="[rulesValidation.required]"
          v-model="buyerData.customer_country"
          :items="countries"
          item-text="country"
          item-value="country"
          @change="changeInput"
        ></v-autocomplete>
      </v-col>
      <v-col
        :class="!$vuetify.breakpoint.mdAndUp ? '' : 'pl-2'"
        :cols="
          !$vuetify.breakpoint.mdAndUp
            ? '12'
            : buyerData?.typeDocument === 'foreigner'
            ? '4'
            : '6'
        "
      >
        <v-row no-gutters>
          <span class="checkout-h3 accent--text" style="font-weight: 400"
            >{{
              buyerData.typeDocument &&
              (buyerData.typeDocument === "CPF" ||
                buyerData.typeDocument === "CNPJ")
                ? $t("general.number")
                : ""
            }}
            {{
              buyerData.typeDocument &&
              (buyerData.typeDocument === "CPF" ||
                buyerData.typeDocument === "CNPJ")
                ? buyerData.typeDocument
                : $t("payment.form.passport")
            }}</span
          >
        </v-row>

        <v-text-field
          class="rounded-lg"
          outlined
          :rules="validateRules()"
          :disabled="!!loggedUser || (pendingOrder && !firstPayment)"
          type="tel"
          v-mask="validateMask()"
          v-model="buyerData.customer_doc"
          @input="changeInput"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row class="mt-n2" no-gutters>
      <span class="checkout-h3 accent--text" style="font-weight: 400">{{
        $t("general.phone")
      }}</span>
    </v-row>
    <v-row no-gutters>
      <v-col style="min-width: 131px; max-width: 131px">
        <v-select
          class="rounded-lg"
          style="
            border-top-right-radius: 0px !important;
            border-bottom-right-radius: 0px !important;
          "
          :disabled="pendingOrder && !firstPayment"
          :items="countries"
          v-model="buyerData.countryPhone"
          item-value="iso"
          outlined
          @change="changeInput('countryPhone')"
        >
          <template v-slot:item="{ item }">
            <v-row no-gutters align="center">
              <div
                :class="`iti-flag-small iti-flag ${item.iso.toLowerCase()}`"
              ></div>
              <span class="ml-2">
                {{ item.country }}
              </span>
            </v-row>
          </template>
          <template v-slot:selection="{ item }">
            <v-row no-gutters align="center">
              <div
                :class="`iti-flag-small iti-flag ${item.iso.toLowerCase()}`"
              ></div>
              <span class="ml-2"> (+{{ item.code }}) </span>
            </v-row>
          </template>
        </v-select>
      </v-col>
      <v-col>
        <v-text-field
          style="
            border-top-left-radius: 0px !important;
            border-bottom-left-radius: 0px !important;
          "
          outlined
          class="rounded-lg"
          :disabled="pendingOrder && !firstPayment"
          v-model="buyerData.customer_phone"
          autocomplete="phone"
          type="tel"
          :rules="[rulesValidation.required, phoneValidation]"
          @input="changeInput('phone')"
        ></v-text-field>
      </v-col>
    </v-row>
    <div id="google-place"></div>
    <div id="google-autocomplete"></div>
    <v-row
      v-if="
        eventDetails.checkout_dados_nf === 2 &&
        buyerData?.typeDocument !== 'foreigner'
      "
      class="mt-n2"
      no-gutters
    >
      <span class="checkout-h3 accent--text" style="font-weight: 400">{{
        $t("general.cityUf")
      }}</span>
    </v-row>
    <div
      v-if="
        eventDetails.checkout_dados_nf === 2 &&
        buyerData?.typeDocument !== 'foreigner'
      "
    >
      <v-autocomplete
        class="rounded-lg"
        outlined
        :disabled="pendingOrder && !firstPayment"
        v-model="buyerData.locationModel"
        item-text="description"
        :item-value="valueFormated"
        :items="eventPlaces ? eventPlaces : []"
        no-data-text="Digite para buscar o local"
        :search-input.sync="location"
        cache-items
        @change="changeInput"
      ></v-autocomplete>
    </div>

    <div
      v-if="
        eventDetails.checkout_dados_nf && eventDetails.checkout_dados_nf === 3
      "
    >
      <v-row class="mt-n2" no-gutters>
        <span class="checkout-h3 accent--text" style="font-weight: 400">{{
          buyerData?.typeDocument === "foreigner"
            ? "Código Postal (Zip Code)"
            : $t("general.cep")
        }}</span>
      </v-row>
      <v-text-field
        v-show="buyerData?.typeDocument === 'foreigner'"
        class="rounded-lg"
        outlined
        :disabled="pendingOrder && !firstPayment"
        autocomplete="postal-code"
        v-model="buyerData.zipcodenomask"
        @input="changeInput"
      ></v-text-field>
      <v-text-field
        v-show="buyerData?.typeDocument !== 'foreigner'"
        class="rounded-lg"
        outlined
        :disabled="pendingOrder && !firstPayment"
        autocomplete="postal-code"
        v-mask="'#####-###'"
        v-model="buyerData.customer_zipcode"
        @input="changeInput"
        @blur="getCepInfo"
      ></v-text-field>
    </div>

    <div
      v-if="
        eventDetails.checkout_dados_nf && eventDetails.checkout_dados_nf === 1
      "
    >
      <v-row class="mt-n2" no-gutters>
        <span class="checkout-h3 accent--text" style="font-weight: 400">{{
          $t("general.cep")
        }}</span>
      </v-row>
      <v-text-field
        v-if="buyerData?.typeDocument === 'foreigner'"
        class="rounded-lg"
        outlined
        required
        :disabled="pendingOrder && !firstPayment"
        autocomplete="postal-code"
        :rules="[rulesValidation.required]"
        v-model="buyerData.zipcodenomask"
        @input="changeInput"
      ></v-text-field>
      <v-text-field
        v-else
        class="rounded-lg"
        outlined
        required
        :disabled="pendingOrder && !firstPayment"
        autocomplete="postal-code"
        :rules="[rulesValidation.required]"
        v-mask="'#####-###'"
        v-model="buyerData.customer_zipcode"
        @input="changeInput"
        @blur="getCepInfo"
      ></v-text-field>
      <v-row class="mt-n2" no-gutters>
        <span class="checkout-h3 accent--text" style="font-weight: 400">{{
          $t("general.roadAvenue")
        }}</span>
      </v-row>
      <v-text-field
        class="rounded-lg"
        outlined
        :disabled="pendingOrder && !firstPayment"
        :rules="[rulesValidation.required]"
        v-model="buyerData.customer_address"
        @input="changeInput"
      ></v-text-field>
      <v-row no-gutters>
        <v-col cols="6">
          <v-row class="mt-n2" no-gutters>
            <span class="checkout-h3 accent--text" style="font-weight: 400">{{
              $t("general.number")
            }}</span>
          </v-row>
          <v-text-field
            class="pr-1 rounded-lg"
            outlined
            :disabled="pendingOrder && !firstPayment"
            :rules="[rulesValidation.required]"
            v-model="buyerData.customer_address_number"
            @input="changeInput"
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-row class="mt-n2" no-gutters>
            <span class="checkout-h3 accent--text" style="font-weight: 400">{{
              $t("general.complement")
            }}</span>
          </v-row>
          <v-text-field
            class="pl-1 rounded-lg"
            outlined
            :disabled="pendingOrder && !firstPayment"
            v-model="buyerData.customer_address_complement"
            @input="changeInput"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row class="mt-n2" no-gutters>
        <span class="checkout-h3 accent--text" style="font-weight: 400">{{
          $t("general.neighborhood")
        }}</span>
      </v-row>
      <v-text-field
        class="rounded-lg"
        outlined
        :disabled="pendingOrder && !firstPayment"
        :rules="[rulesValidation.required]"
        v-model="buyerData.customer_neighborhood"
        @input="changeInput"
      ></v-text-field>
      <v-row class="mt-n2" no-gutters>
        <span class="checkout-h3 accent--text" style="font-weight: 400">{{
          $t("general.city")
        }}</span>
      </v-row>
      <v-text-field
        class="rounded-lg"
        outlined
        :disabled="pendingOrder && !firstPayment"
        :rules="[rulesValidation.required]"
        v-model="buyerData.customer_city"
        @input="changeInput"
      ></v-text-field>
      <v-row class="mt-n2" no-gutters>
        <span class="checkout-h3 accent--text" style="font-weight: 400">{{
          $t("general.state")
        }}</span>
      </v-row>
      <v-text-field
        class="rounded-lg"
        outlined
        :disabled="pendingOrder && !firstPayment"
        :rules="[rulesValidation.required]"
        v-model="buyerData.customer_state"
        @input="changeInput"
      ></v-text-field>
      <v-row class="mt-n2" no-gutters>
        <span class="checkout-h3 accent--text" style="font-weight: 400">{{
          $t("general.country")
        }}</span>
      </v-row>
      <v-autocomplete
        v-if="buyerData?.typeDocument !== 'foreigner'"
        class="rounded-lg"
        outlined
        :disabled="pendingOrder && !firstPayment"
        :rules="[rulesValidation.required]"
        v-model="buyerData.customer_country"
        :items="countries"
        item-text="country"
        item-value="country"
        @change="changeInput"
      ></v-autocomplete>
    </div>
  </div>
</template>

<script>
import { AsYouType, validatePhoneNumberLength } from "libphonenumber-js";
import validationMixin from "../../mixins/validationMixin.vue";
import { mask } from "vue-the-mask";
import { mapGetters } from "vuex";

export default {
  directives: { mask },
  mixins: [validationMixin],
  data() {
    return {
      buyerData: {
        typeDocument: "CPF",
        customer_country: "",
        countryPhone: "BR",
      },
      location: "",
      emailAvailable: true,
      typesDocument: [
        "CPF",
        "CNPJ",
        { text: "Estrangeiro (Foreigner)", value: "foreigner" },
      ],
      phone: null,
    };
  },
  computed: {
    ...mapGetters([
      "eventDetails",
      "countries",
      "eventPlaces",
      "orderDetails",
      "buyer",
      "loggedUser",
      "interests",
      "firstPayment",
      "pendingOrder",
      "eventId",
    ]),
  },
  mounted() {
    this.$store.commit("SET_BUYER_DATA", {});

    if (this.$route.query.order_hash && this.orderDetails.dados_comprador)
      this.setOrderHashData();
    else this.setLoggedUserData();
    this.buyerData.customer_country = "Brasil";
  },
  watch: {
    loggedUser(v) {
      if (!v) {
        this.buyerData = {
          typeDocument: "CPF",
          customer_country: "Brasil",
          customer_doc: "",
          customer_phone: "",
          countryPhone: "BR",
        };

        this.getCorrectBugMask();

        this.$store.commit("SET_BUYER_DATA", {
          ...this.buyerData,
        });
      } else {
        this.setLoggedUserData();
      }
    },
    location(v) {
      if (v && v.length >= 3) {
        this.searchLocation(v);
      } else this.$store.commit("SET_ALL_EVENT_PLACES", []);
    },
    buyerData(v) {
      if (v) this.$store.commit("SET_BUYER_DATA", { ...this.buyer, ...v });
    },
  },
  methods: {
    setOrderHashData() {
      this.buyerData = {
        customer_doc: this.orderDetails.dados_comprador.documento,
        customer_email: this.orderDetails.dados_comprador.email,
        emailConfirmation: this.orderDetails.dados_comprador.email,
        customer_name: this.orderDetails.dados_comprador.nome,
        countryPhone: "BR",
        customer_phone: new AsYouType("BR").input(
          this.orderDetails.dados_comprador.telefone
        ),
        typeDocument: "CPF",
      };
      this.getCorrectBugMask();
    },
    async setLoggedUserData() {
      if (this.loggedUser && !this.$route.query.order_hash) {
        this.buyerData = {
          customer_doc: this.loggedUser.document,
          customer_email: this.loggedUser.email,
          emailConfirmation: this.loggedUser.email,
          countryPhone: "BR",
          customer_name: `${this.loggedUser.name} ${this.loggedUser.lastname}`,
          customer_phone: new AsYouType("BR").input(this.loggedUser.phone),
          typeDocument: "CPF",
        };
        this.getCorrectBugMask();
        this.changeInput();
      }
    },

    clearAddressInformation() {
      this.buyerData.customer_neighborhood = "";
      this.buyerData.customer_address = "";
      this.buyerData.customer_city = "";
      this.buyerData.customer_state = "";
    },

    changeInput(type) {
      if (type && type === "phone") {
        this.buyerData.customer_phone = new AsYouType(
          this.buyerData.countryPhone
        ).input(this.buyerData.customer_phone);
      }

      if (
        type &&
        type === "typeDocument" &&
        this.buyerData.typeDocument === "foreigner"
      ) {
        this.buyerData.customer_zipcode = "";
        if (this.eventDetails.checkout_dados_nf === 3) {
          this.clearAddressInformation();
        }
      }

      if (type && type === "countryPhone") {
        this.buyerData.customer_phone = "";

        if (this.buyerData.countryPhone !== "BR") {
          this.buyerData.installment_amount =
            this.interests?.parcelas[0]?.value;
        }
      }
      this.$store.commit("SET_BUYER_DATA", {
        ...this.buyer,
        ...this.buyerData,
      });
    },
    async getAvailable() {
      if (this.rulesValidation.email(this.buyerData.customer_email) === true) {
        this.$store
          .dispatch("getAvailableEmail", this.buyerData.customer_email)
          .then((resp) => {
            this.emailAvailable = resp?.data?.available;
          });
        let params = {
          codigo_evento: this.eventId,
          ccodigo_pedido: this.orderDetails.codigo,
          email: this.buyerData.customer_email,
        };
        this.$store.dispatch("registerBuyerInfo", params);
      }
    },
    valueFormated(v) {
      let valueReplace = v.description.replace(", ", " - ").split(" - ");
      return `${valueReplace[0]}/${valueReplace[1]}/${valueReplace[2]}`;
    },
    async searchLocation(v) {
      await this.$store.dispatch("getGlobalPlaces", v);
    },
    validateMask() {
      if (this.buyerData.typeDocument === "CPF") return "###.###.###-##";
      else if (this.buyerData.typeDocument === "CNPJ")
        return "##.###.###/####-##";
      else return "XXXXXXXXXXXXXXXXXXXXXXXXXXXXX";
    },
    validateRules() {
      if (this.buyerData.typeDocument === "CPF") return this.cpfRules;
      else if (this.buyerData.typeDocument === "CNPJ") return this.cnpjRules;
      else return [this.rulesValidation.required];
    },
    // BUG V-MASK
    keyPressPhone(event) {
      if (!/^[0-9]+$/.test(event.key)) event.preventDefault();
      if (this.buyerData.customer_phone) {
        let copy =
          new AsYouType(this.buyerData.countryPhone).input(
            this.buyerData.customer_phone
          ) + "1";
        if (
          validatePhoneNumberLength(copy, this.buyerData.countryPhone) ===
          "TOO_LONG"
        )
          event.preventDefault();
        else
          this.buyerData.customer_phone = new AsYouType(
            this.buyerData.countryPhone
          ).input(this.buyerData.customer_phone);
      }
    },

    getCepInfo() {
      if (
        this.buyerData.customer_zipcode &&
        this.buyerData.customer_zipcode.length === 9 &&
        this.buyerData?.typeDocument !== "foreigner"
      ) {
        var xmlHttp = new XMLHttpRequest();
        xmlHttp.open(
          "GET",
          `https://viacep.com.br/ws/${this.buyerData.customer_zipcode.replace(
            "-",
            ""
          )}/json/`,
          false
        ); // false for synchronous request
        xmlHttp.send(null);

        const response = JSON.parse(xmlHttp.responseText);
        if (!response.erro) {
          this.buyerData = {
            ...this.buyerData,
            customer_neighborhood: response.bairro,
            customer_address: response.logradouro,
            customer_city: response.localidade,
            customer_state: response.uf,
          };
        } else {
          this.clearAddressInformation();
        }
      }
    },

    phoneValidation(v) {
      if (v && v.length) {
        if (this.buyerData.countryPhone === "BR" && v.length < 14)
          return "Telefone" + this.$t("errors.invalid");
        if (validatePhoneNumberLength(v, this.buyerData.countryPhone))
          return "Telefone" + this.$t("errors.invalid");
        else return true;
      } else return true;
    },
    getCorrectBugMask() {
      setTimeout(() => {
        this.buyerData = {
          ...this.buyerData,
        };
      }, 100);
    },
  },
};
</script>

<style scoped>
.internationalInput .select-country-container {
  min-height: 51px !important;
}
</style>

<style>
#MazPhoneNumberInput-41_country_selector {
  min-height: 51px !important;
}

#MazPhoneNumberInput-41_phone_number {
  min-height: 51px !important;
}

.input-tel__input {
  min-height: 51px !important;
}

.country-selector__input {
  min-height: 51px !important;
}
</style>

<style lang="scss" scoped>
@import "../../assets/flags/flags.css";
</style>
